


























































declare const componentHandler: any;

import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import MessageList from '../components/MessageList.vue';
import Mixin from '../mixin';
import OrgInfo from '../class/OrgInfo';

@Component({
  components: { MessageList },
})
export default class GroupDetail extends Mixin {
  @Prop() private groupid!: string;
  @State private user!: any;
  @State private showOrg!: string;
  @State private group!: any;
  @State private organization!: OrgInfo[];
  @Mutation private updateTitle!: (name: string) => void;
  @Mutation private setGroup!: (obj: {id: string, groups: OrgInfo[]}) => void;
  @Mutation private setOrganization!: (org: OrgInfo) => void;
  @Mutation('showOrg') private setShowOrg!: (id: string) => void;
  private org: OrgInfo | null = null;
  private usePass: boolean = false;
  private pass: string = '';

  private async mounted() {
    try {
      if ((!this.organization || this.organization.length === 0) && navigator.onLine) {
        await this.setOrganization(await API.post('api', '/organization', {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        }));
      }
      this.org = await this.getGroup();
      this.updateTitle(this.org!.Name);
      this.setShowOrg(this.org!.Parent && this.org!.Parent.length > 0 ? this.org!.Parent : this.org!.ID);
      if (this.org !== undefined && this.org !== null && this.org!.Password !== '') {
        this.usePass = true;
      }
    } catch (ex) {
      this.msg(ex);
    }
  }

  private async getGroup() {
    const filtered = this.group[this.showOrg]
      ? this.group[this.showOrg].filter((g: OrgInfo) => g.ID === this.groupid)
      : [];
    let org = filtered.length > 0 ? filtered[0] : this.organization.filter((o: OrgInfo) => o.ID === this.groupid)[0];
    if (!navigator.onLine) {
      return org;
    }
    try {
      org = await API.get('api', `/group/get?id=${this.groupid}`, {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      }) as OrgInfo;
    } catch (ex) {
      this.msg(ex);
    }
    return org;
  }

  private async changePass(event: any) {
    if (event.target.disabled) {
      return;
    }
    try {
      event.target.disabled = true;
      if (this.usePass && this.pass.length > 0) {
        this.org!.Password = this.pass;
      } else {
        this.org!.Password = '';
      }
      await API.post('api', '/group/update/pass', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken},
        body: this.org,
      });
      if (this.usePass && this.pass.length > 0) {
        this.msg('パスワードを変更しました');
      } else {
        this.msg('パスワードを削除しました');
        this.usePass = false;
        this.$el.querySelector('#usePass')!.parentElement!.classList.remove('is-checked');
      }
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }

  private upgradeDom() {
    setTimeout(() => {
      componentHandler.upgradeDom();
    }, 100);
  }

  private async clearSubscribe(event: any) {
    this.confirm('購読者を全削除します。\nよろしいですか?', async () => {
      try {
        event.target.disabled = true;
        this.block();
        await API.post('api', '/group/clear', {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken},
          body: {OrganizationID: this.groupid},
        });
        this.msg('購読者を削除しました');
        this.org = await API.get('api', `/group/get?id=${this.groupid}`, {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        }) as OrgInfo;
      } catch (ex) {
        this.msg(ex);
      } finally {
        this.unblock();
        event.target.disabled = false;
      }
    });
  }

}
